import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { DashboardStoreEffects } from './dashboard.effects';
import { dashboardStoreFeatureKey, reducer } from './dashboard.reducers';
import { provideOccupancyStore } from './occupancy';
import { provideReservationsStore } from './reservations';
import { provideRevenueStore } from './revenue';
import { provideRevenueByChannelStore } from './revenue-by-channel';
import { provideRevenueBySourceStore } from './revenue-by-source';

export function provideDashboardStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(dashboardStoreFeatureKey, reducer),
    provideEffects([DashboardStoreEffects]),
    provideRevenueStore(),
    provideReservationsStore(),
    provideOccupancyStore(),
    provideRevenueBySourceStore(),
    provideRevenueByChannelStore(),
  ]);
}
